class ProductCarousel extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.carousel = this.querySelector('.carousel--root')),
      (this.media = this.carousel.querySelectorAll('.product-media--root')),
      (this.transition_container = this.carousel.querySelector(
        '.carousel--x-container'
      )),
      this.carousel.on('loaded', () => {
        this.updateMediaListener(), this.onSlideFinishedListener();
        var e = this.querySelector('.product-media--root[data-active="true"]');
        this.goToSlide(0);
      });
  }
  updateMediaListener() {
    window.on(
      `theme:product:${this.dataset.id}:variantChanged`,
      ({ detail: { variant: e } }) => {
        var t = e.featured_media ? parseInt(e.featured_media.id) : 0;
        this.goToSlide(t);
      }
    );
  }
  onSlideFinishedListener() {
    this.transition_container.on('transitionend', () => {
      var e = this.carousel.active_slide - 1,
        t = this.media[e];
      this.media.not(t).forEach((e) => e.firstChild.trigger('pauseMedia'));
    });
  }
  goToSlide(e) {
    var t, i;
    0 !== e &&
      (t = this.carousel.querySelector(
        `.product-media--root[data-id='${e}']`
      )) &&
      ((i = t.closest('.carousel--block').index() + 1),
      this.carousel.updateThenGoToActiveSlide(i));
      console.log(i)
  }
}
const productCarouselEl = customElements.get('product-media-carousel');
productCarouselEl ||
  customElements.define('product-media-carousel', ProductCarousel);
